export interface AuthError {
  id: number;
  title: string;
}
